var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.url != '')?_c('div',{staticStyle:{"border-radius":"10px","width":"100px","background":"#f1f1f1"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],attrs:{"src":_vm.url},on:{"error":_vm.onError,"load":_vm.onLoad}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }